<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加</el-button>
            <el-button  class="top-btn" type="danger"  plain @click="handleBatch(3)" >删除</el-button>
        </div>

        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无规格" height="650"  style="width:100%;">
                <el-table-column type="selection"  width="80"        align="center"> </el-table-column>
                <el-table-column prop="title"      label="中文名称"  align="center"></el-table-column>
                <el-table-column prop="title_en"   label="英文名称"  align="center"></el-table-column>
                <el-table-column prop="sort_id"    label="排序"      align="center" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort_id" @change="handleSort(scope.row)" size="small" style="width:100px"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="small"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="small"  @click="handleDel(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" hide-on-single-page layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>

        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>中文名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="title" placeholder="请输入中文"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>英文名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="title_en" placeholder="请输入英文"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>排序：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="sort_id"></el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { specs, specs_add, specs_put, specs_del } from '@/api/buy.js'

export default {
    data() {
        return {
            tableData: [],
            page:1,
            size:20,
            total:0,
            dialog:false,    // 控制显示 添加修改弹窗
            ids:[],          // table 选中数据的 id 数组集合
            dialogTitle:'添加管理员',
            id:'',           //  有id 是修改  没有id是添加
            title:'',
            title_en:'',
            sort_id:1,
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            let params = {
                page:this.page,
                language:'zh'
            }
            specs(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            })
        },
        reloadData(page){
            this.page = page
            this.handleData()
        },
 
        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                console.log(row)
                this.dialog      = true
                this.dialogTitle = '修改规格'
                this.id          = row.id
                this.title       = row.title
                this.title_en    = row.title_en
                this.sort_id     = 1
            }else{
                this.dialog      = true
                this.dialogTitle = '添加规格'
                this.id          = ''
                this.title       = ''
                this.title_en    = ''
                this.sort_id     = 1
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                title:this.title,
                sort_id:this.sort_id,
                status:this.status,
                language:'zh'
            }
            specs_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改栏目函数
        handlePut(){
            let params = {
                title:this.title,
                title_en:this.title_en,
                sort_id:this.sort_id,
            }
            specs_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                    
                }
            })
        },
        // 修改状态
        handleStatus(id,status){
            specs_put(id,{status:status}).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改排序
        handleSort(row){
            let params = {
                sort_id:row.sort_id
            }
            specs_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 点击删除 
        handleDel(id){
            this.$confirm(`此操作将删除规格, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                specs_del(id).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.id)
            })
        },
        // 批量操作  1 启用 2 禁用 3 删除
        handleBatch(index){
            if(this.ids.length == 0){
                this.$message({type:'error',message:'请至少选中一条数据进行批量操作哦',})
                return false;
            }
            if(index == 1){
                this.handleStatus(this.ids,1)
            }else if(index == 2){
                 this.handleStatus(this.ids,0)
            }else if(index == 3){
                this.handleDel(this.ids)
            }
        },
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>